<template>
  <div class="wrap_all">
    <NavBar />
    <router-view />
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";

export default {
  components: {
    NavBar
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "./assets/styles/base.css";
@import "./assets/styles/contact.css";
@import "./assets/styles/heading.css";
@import "./assets/styles/enfold.css";
@import "./assets/styles/avia-snippet-lightbox.css";
@import "./assets/styles/avia-snippet-site-preloader.css";
@import "./assets/styles/avia-snippet-widget.css";
@import "./assets/styles/custom.css";
@import "./assets/styles/grid.css";
@import "./assets/styles/layout.css";
@import "./assets/styles/shortcodes.css";
.app-background {
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
}
</style>
